var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.agentSynonyms.length > 0)?_c('div',[_c('h1',{staticClass:"is-size-5 has-margin-bottom-small"},[_vm._v("Synonyms for the Agent")]),_c('b-table',{attrs:{"columns":_vm.columns,"data":_vm.agentSynonyms}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }